import { __rest, __assign } from '../../../_virtual/_tslib.js';
import React, { useEffect } from 'react';
import classnames from 'classnames';
import ScrollLock, { TouchScrollable } from 'react-scrolllock';
import ReactModal from 'react-modal';
import upperFirst from 'lodash/upperFirst';
import elevationStyles from '../../../elevations.css.js';
import styles from './styles.css.js';
import Close from './close.svg.js';
import { useSpring, animated } from 'react-spring';

var FancyModal = function FancyModal(_a) {
  var children = _a.children,
      disableScrollLock = _a.disableScrollLock,
      isOpen = _a.isOpen,
      onRequestClose = _a.onRequestClose,
      hideCloseButton = _a.hideCloseButton,
      className = _a.className,
      modalContentClassName = _a.modalContentClassName,
      overlayClassName = _a.overlayClassName,
      closeTestId = _a.closeTestId,
      _b = _a.elevation,
      elevation = _b === void 0 ? 'lowest' : _b,
      rest = __rest(_a, ["children", "disableScrollLock", "isOpen", "onRequestClose", "hideCloseButton", "className", "modalContentClassName", "overlayClassName", "closeTestId", "elevation"]);

  useEffect(function () {
    ReactModal.setAppElement('body');
  }, []);
  var animationProps = useSpring({
    transform: isOpen ? 'translateY(0%)' : 'translateY(100%)'
  });
  return React.createElement(ReactModal, __assign({
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    className: classnames(styles.modal, className),
    overlayClassName: classnames(styles.overlay, elevationStyles["elevation" + upperFirst(elevation)], overlayClassName)
  }, rest), React.createElement(ScrollLock, {
    isActive: disableScrollLock ? false : isOpen
  }), React.createElement(React.Fragment, null, onRequestClose && !hideCloseButton && React.createElement("div", {
    className: styles.closeContainer,
    "data-testid": closeTestId,
    onClick: function onClick(e) {
      return onRequestClose && onRequestClose(e);
    }
  }, React.createElement(Close, {
    className: styles.close
  })), React.createElement(TouchScrollable, null, React.createElement(animated.div, {
    className: classnames(styles.modalContent, modalContentClassName),
    style: animationProps
  }, children))));
};

export default FancyModal;
//# sourceMappingURL=index.js.map
